<template>
    <div>
        <div class="pl-3">

            <div class="sub-header">Authentication</div>
            ในการเรียกใช้ API จะต้องระบุ <code>X-API-KEY</code> มาใน Request Header ทุกครั้ง
            <div>
                <small class="text--secondary">หมายเหตุ: หากต้องการใช้ API กรุณาติดต่อเรา เพื่อขอรับ API KEY</small>
            </div>
            <b>ตัวอย่าง</b>
            <div v-highlight><pre class="language-bash"><code>$ curl https://open.lnwshop.com/123456/api/v1/order/list \
-X POST \
-H "X-API-KEY: AAABBBCCCDDDEEEFFFGGGHHHIIIJJJKKK" \
-H "Content-Type: application/json" \
--data '{"pagination_offset":0,"pagination_limit":10}'
            </code></pre></div>

            <div class="sub-header">Response</div>
            <response></response>

        </div>
    </div>
</template>

<script>
    import Response from "./Response";
    export default {
        name: "Introduction",
        components: {Response},
    }
</script>

<style lang="scss">
    .sub-header {
        font-size: 1.2em;
        font-weight: bold;
        margin-top: 2em;
    }
</style>